import React, { useState } from 'react'
import { Modal } from 'react-bootstrap'
import Select from 'react-select';
import { DatePicker } from 'antd';

const UploadActiveInventory = ({ show, setShow }) => {

    const onHide = () => {
        setShow(false);
    }

    const list = [
        { label: 'item 1', value: 1 },
        { label: 'item 2', value: 2 },
        { label: 'item 3', value: 3 },
        { label: 'item 4', value: 4 },
    ]

    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

    const handleSelectDate = (name, value) => {
        if (name === "startDate") {
            setStartDate(value);
        }
        else {
            setEndDate(value);
        }
    }

    return (
        <div>
            <Modal
                show={show}
                onHide={() => onHide()}
                size='lg'
                backdrop="static"
                centered
            >

                <Modal.Header closeButton className='modal-header-border'>
                    <h4> Upload Activity inventory </h4>
                </Modal.Header>

                <Modal.Body>
                    <div className="form_border py-4 px-4">
                        <div className="row">
                            <div className="col-lg-4 col-md-4 col-12 mb-2">
                                <label htmlFor="ActivityNameId" className='col-form-label required'> Activity Name </label>
                            </div>
                            <div className="col-lg-8 col-md-8 col-12 mb-2">
                                <Select
                                    className="dropdown select_dropdown text-center"
                                    inputId='ActivityNameId'
                                    options={list}
                                    isSearchable
                                    placeholder='Activity Name'
                                />
                            </div>

                            <div className="col-lg-4 col-md-4 col-12 mb-2">
                                <label htmlFor="VariantsId" className='col-form-label required'> Variants </label>
                            </div>
                            <div className="col-lg-8 col-md-8 col-12 mb-2">
                                <Select
                                    className="dropdown select_dropdown text-center"
                                    inputId='VariantsId'
                                    options={list}
                                    isSearchable
                                    placeholder='Variants'
                                />
                            </div>

                            <div className="col-lg-4 col-md-4 col-12 mb-2">
                                <label htmlFor="VariantsId" className='col-form-label required'> Inventory </label>
                            </div>
                            <div className="col-lg-8 col-md-8 col-12 mb-2">
                                <div className="d-md-flex align-items-center">
                                    <div className="form-check mb-md-0 mb-1">
                                        <input className="form-check-input" type="checkbox" value="" id="checkDefault" />
                                        <label className="form-check-label text-nowrap" for="checkDefault">
                                            Un-limited
                                        </label>
                                    </div>
                                    <div className="ms-md-2 w-100">
                                        <input
                                            className='form-control'
                                            type="text"
                                            name=""
                                            id=""
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4 col-md-4 col-12 mb-2">
                                <label htmlFor="TimeSlotsId" className='col-form-label'> Time Slots </label>
                            </div>
                            <div className="col-lg-8 col-md-8 col-12 mb-2">
                                <Select
                                    className="dropdown select_dropdown text-center"
                                    inputId='TimeSlotsId'
                                    options={list}
                                    isSearchable
                                    placeholder='Select All'
                                />
                            </div>

                            <div className="col-lg-4 col-md-4 col-12 mb-2">
                                <label htmlFor="StartDate" className='col-form-label required'> Start Date </label>
                            </div>
                            <div className="col-lg-8 col-md-8 col-12 mb-2  text-center">
                                <DatePicker
                                    className='antd_input w-100 antd-input-text-center'
                                    format='DD/MM/YYYY'
                                    placeholder="Start Date"
                                    value={startDate}
                                    onChange={(e) => handleSelectDate("startDate", e)}
                                />
                            </div>

                            <div className="col-lg-4 col-md-4 col-12 mb-2">
                                <label htmlFor="EndDate" className='col-form-label required'> End Date </label>
                            </div>
                            <div className="col-lg-8 col-md-8 col-12 mb-2">
                                <DatePicker
                                    className='antd_input w-100 antd-input-text-center'
                                    format='DD/MM/YYYY'
                                    placeholder="End Date"
                                    value={endDate}
                                    onChange={(e) => handleSelectDate("endDate", e)}
                                />
                            </div>

                            <div className="col-lg-4 col-md-4 col-12 mb-2">
                            </div>
                            <div className="col-lg-8 col-md-8 col-12 mb-2 d-flex">
                                <div className="form-check">
                                    <input className="form-check-input" type="radio" name="radiodate" id="PerDate" />
                                    <label className="form-check-label" for="PerDate">
                                        Per Date
                                    </label>
                                </div>
                                <div className="form-check ms-md-2">
                                    <input className="form-check-input" type="radio" name="radiodate" id="CompleteRange" />
                                    <label className="form-check-label" for="CompleteRange">
                                        Complete Range
                                    </label>
                                </div>
                            </div>
                        </div>

                        <center className="mt-3" >
                            <button type="button" className='btn btn-primary w-25'> Save </button>
                        </center>
                    </div>
                </Modal.Body>

            </Modal>
        </div>
    )
}

export default UploadActiveInventory
